// extracted by mini-css-extract-plugin
export default {"container":"Coverage_container__bDz6O","types":"Coverage_types__OPyef","type":"Coverage_type__3t+zn"};